import Subject from "../cse4sub/Subject";
import React from 'react'

export default function Cn() {
  return (
    <div>
       <Subject title="Computer Networks(CSE602)" sub="Computer Networks" syllabus="#"
    book1="Data Communication and Networking, 4th Edition, Behrouz A. Forouzan, McGraw-Hill"
     book2="Data and Computer Communication, 8th Edition, William Stallings, Pearson Prentice Hall India."
    book1Link="http://eti2506.elimu.net/Introduction/Books/Data%20Communications%20and%20Networking%20By%20Behrouz%20A.Forouzan.pdf
    " book2Link="https://www.pdfdrive.com/download.pdf?id=185821385&h=f4e41fb71fc6edb42bde77fd7542ec36&u=cache&ext=pdf
    " int21="#" mid21="#" end21="#"
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}